var _rect, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaqLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white",
    rx: 10
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 95,
    textAnchor: "middle",
    fontFamily: "Arial,Helvetica,sans-serif",
    fontSize: 56,
    fontWeight: "bold",
    fill: "#B71C1C",
    letterSpacing: -2
  }, "MAQ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 145,
    textAnchor: "middle",
    fontFamily: "Arial,Helvetica,sans-serif",
    fontSize: 36,
    fontWeight: 400,
    fill: "#666666"
  }, "Software")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaqLogo);
export default __webpack_public_path__ + "static/media/maq-logo.17f3ac8afe67396bf45ad74baf54bac5.svg";
export { ForwardRef as ReactComponent };